import { request } from '@/shared/api/request'

export const createOccupationalRisk = (data) => {
	return request({ url: '/assessment/create/application', method: 'POST', data })
}
